import { SUBJECTS } from '../learning/subjects'
import { type SampleMaterial, type SelfReport } from './model'
import { type EvidenceStatus } from './report'

/**
 * Text and styles shared by the School Material Learning Journey screens and
 * the parent preview. The DEMO texts keep the original source, simulated
 * extraction and pre-authored explanation visibly apart (Curriculum and
 * Source-Based Learning §7).
 */

export const JOURNEY_STEPS = [
  'Tài liệu',
  'Nội dung',
  'Chủ đề',
  'Học',
  'Luyện tập',
  'Kết quả',
] as const

export type JourneyStep = (typeof JOURNEY_STEPS)[number]

export const DEMO_TEXT = {
  source: 'Tài liệu mẫu để thử, không phải ảnh tài liệu thật.',
  extraction:
    'Mô phỏng: nội dung này được soạn sẵn. Ứng dụng chưa có chức năng đọc ảnh hay PDF.',
  explanation: 'Giải thích soạn sẵn để thử. Không phải AI đang chạy.',
  help: 'Trợ giúp soạn sẵn để thử. Không phải AI đang chạy.',
  result: 'Kết quả của lượt thử với tài liệu mẫu. Không lưu vào hồ sơ học tập của con.',
} as const

export const NOT_CONNECTED_TEXT =
  'Ứng dụng chưa đọc được nội dung tài liệu này: chức năng đọc ảnh và PDF chưa được kết nối.'

export const LOCAL_ONLY_TEXT = 'Tệp chỉ được xem trên máy này, không gửi đi đâu.'

/** Where reading is available (Slice 3): nothing leaves the device before "Gửi để đọc". */
export const SEND_ONLY_TEXT =
  'Tệp chỉ được gửi đi khi con bấm “Gửi để đọc”. Trước đó, tệp chỉ ở trên máy này.'

export const SELF_REPORT_TEXT: Readonly<Record<SelfReport, string>> = {
  understood: 'Con hiểu rồi',
  partly: 'Hiểu một phần',
  again: 'Cần giải thích lại',
}

export const STATUS_TEXT: Readonly<Record<EvidenceStatus, string>> = {
  difficulty_suggested: 'Có một lỗi lặp lại: nên xem lại phần này.',
  mixed: 'Có câu chưa đúng, chưa thấy lỗi nào lặp lại.',
  insufficient_evidence: 'Chưa đủ dữ liệu để nhận xét.',
  no_difficulty_observed: 'Chưa thấy khó khăn trong các câu đã làm.',
}

export const NO_MASTERY_TEXT =
  'Vài câu luyện tập chưa đủ để nói con đã nắm vững chủ đề này.'

export const PARENT_NO_MASTERY_TEXT =
  'Vài câu luyện tập chưa đủ để kết luận đã nắm vững chủ đề này.'

export const PRIMARY =
  'flex h-14 items-center justify-center rounded-2xl bg-sky-700 px-6 text-lg font-semibold text-white active:bg-sky-800 disabled:opacity-40 md:min-w-72'
export const SECONDARY =
  'flex h-12 items-center justify-center rounded-2xl border-2 border-slate-300 bg-white px-5 text-lg font-semibold text-slate-800 active:bg-slate-50 dark:border-slate-700 dark:bg-slate-900 dark:text-slate-100'
export const PANEL =
  'flex flex-col gap-3 rounded-3xl border-2 border-slate-200 bg-white p-4 dark:border-slate-800 dark:bg-slate-900'

export function subjectOf(sample: SampleMaterial) {
  return SUBJECTS.find((s) => s.code === sample.subject)
}
